export default "__VITE_ASSET__CqjoP24n__"